// extracted by mini-css-extract-plugin
export default {"fullMaxWidth":"xK-z","carouselContainer":"yK-z"};